<template>
  <multiple_form
    :forms="forms"
    :edit="false"
    :editData="props.editData"
    @submit="handelSubmit"
    ref="formRef"
  />
</template>
<script setup>
  import { defineProps, defineEmits, computed,ref } from 'vue'
  import { message } from 'ant-design-vue'
  import { alarmDeal } from '@/api/stranded_management/car'
  import multiple_form from '@/components/multiple_form'
  import { yesOrNot } from '@/utils/common'
  import { constantToOptions } from '@/utils/format'

  //初始化
  const formRef = ref()
  const props = defineProps({
    isEdit: Boolean,
    canEdit: Boolean,
    editData: Object,
    data: Array,
    idField: String,
    disabled: Boolean,
  })
  const emit = defineEmits(['submit'])

  //编辑、新增的表单
  const forms = computed(() => [
    {
      name: '',
      id: 'handelAlarm',
      itemWidth: '420px',
      formItem: [
        {
          type: 'radio',
          field: 'false_alarm',
          options: constantToOptions(yesOrNot),
          label: '是否误判',
          onChange: (val) => {
            if (
              formRef.value &&
              formRef.value.formRefs &&
              formRef.value.formRefs.handelAlarm &&
              formRef.value.formRefs.handelAlarm.formState
            ) {
              formRef.value.formRefs.handelAlarm.formState.handled_remark =
                val.target.value === '1' ? '出现误判！' : '判断准确！'
            }
          },
        },
        {
          type: 'input',
          field: 'handled_remark',
          label: '处理批注',
        },
      ],
    },
  ])

  async function handelSubmit(data) {
    const res = await alarmDeal({
      ...data,
      [props.idField]: props.editData[props.idField],
    })
    if (res.success) {
      message.success('处理告警成功！')
      emit('submit')
    } else {
      message.warn('处理告警错误：', res.message)
    }
  }
</script>
